"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _reactPopper = require("react-popper");
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _lodash2 = _interopRequireDefault(require("lodash.isundefined"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenUtils = require("@8x8/oxygen-utils");
var _oxygenDateTimeBase = _interopRequireDefault(require("@8x8/oxygen-date-time-base"));
var _DateTimeSelectorDropdown = _interopRequireDefault(require("./DateTimeSelectorDropdown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function DateTimeSelector(_ref) {
  var closeOnDateChange = _ref.closeOnDateChange,
    hasError = _ref.hasError,
    placeholder = _ref.placeholder,
    finishButtonLabel = _ref.finishButtonLabel,
    inputIcon = _ref.inputIcon,
    iconLeft = _ref.iconLeft,
    isClearable = _ref.isClearable,
    isDisabled = _ref.isDisabled,
    onBlur = _ref.onBlur,
    onDateChange = _ref.onDateChange,
    onFocus = _ref.onFocus,
    otherCalendarProps = _ref.otherCalendarProps,
    id = _ref.id,
    size = _ref.size,
    testId = _ref.testId,
    theme = _ref.theme,
    titleFormatPattern = _ref.titleFormatPattern,
    titleFormatter = _ref.titleFormatter,
    value = _ref.value;
  var inputRef = /*#__PURE__*/_react["default"].createRef();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDropdownVisible = _useState2[0],
    setIsDropdownVisible = _useState2[1];
  var handleSetIsDropdownVisible = function handleSetIsDropdownVisible(dropDownVisibleValue) {
    if (!dropDownVisibleValue) {
      onBlur();
    }
    setIsDropdownVisible(dropDownVisibleValue);
  };
  var setInputRef = function setInputRef(node) {
    inputRef.current = node;
  };
  var onClickOutside = function onClickOutside(e) {
    var _inputRef$current, _inputRef$current$con;
    // handle clicking on the original input
    if (inputRef !== null && inputRef !== void 0 && (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && (_inputRef$current$con = _inputRef$current.contains) !== null && _inputRef$current$con !== void 0 && _inputRef$current$con.call(_inputRef$current, e.target)) {
      return;
    }
    handleSetIsDropdownVisible(false);
  };
  var getTitle = function getTitle() {
    if (!value) {
      return placeholder;
    }
    if (titleFormatter) {
      return titleFormatter(value);
    }
    return (0, _format["default"])(value, titleFormatPattern);
  };
  var onClear = function onClear() {
    onFocus();
    onDateChange(undefined);
    onBlur();
  };
  var onClick = function onClick() {
    if (!isDropdownVisible) {
      onFocus();
    }
    handleSetIsDropdownVisible(!isDropdownVisible);
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_reactPopper.Manager, null, /*#__PURE__*/_react["default"].createElement(_reactPopper.Reference, null, function (_ref2) {
    var ref = _ref2.ref;
    return /*#__PURE__*/_react["default"].createElement(_oxygenDateTimeBase["default"], {
      hasError: hasError,
      iconLeft: iconLeft,
      id: id,
      isClearable: isClearable,
      isDisabled: isDisabled,
      isOpen: isDropdownVisible,
      inputIcon: inputIcon,
      isValueSelected: !(0, _lodash2["default"])(value),
      onClear: onClear,
      onClick: onClick,
      popperAnchorRef: ref,
      size: size,
      testId: "".concat(testId, "_INPUT"),
      theme: theme,
      title: getTitle(),
      setInputRef: setInputRef
    });
  }), isDropdownVisible && /*#__PURE__*/_react["default"].createElement(_reactPopper.Popper, {
    placement: "bottom",
    positionFixed: true
  }, function (_ref3) {
    var ref = _ref3.ref,
      style = _ref3.style;
    return /*#__PURE__*/_react["default"].createElement(_oxygenUtils.OutsideEventBehavior, {
      onClick: onClickOutside
    }, /*#__PURE__*/_react["default"].createElement(_DateTimeSelectorDropdown["default"], {
      closeOnDateChange: closeOnDateChange,
      dropdownRef: ref,
      finishButtonLabel: finishButtonLabel,
      onDateChange: onDateChange,
      otherCalendarProps: otherCalendarProps,
      setIsDropdownVisible: handleSetIsDropdownVisible,
      style: style,
      testId: "".concat(testId, "_DROPDOWN"),
      value: value
    }));
  })));
}
DateTimeSelector.propTypes = {
  closeOnDateChange: _propTypes["default"].bool,
  hasError: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  finishButtonLabel: _propTypes["default"].string,
  inputIcon: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  iconLeft: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].elementType]),
  isClearable: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  onBlur: _propTypes["default"].func,
  onDateChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  otherCalendarProps: _propTypes["default"].object,
  id: _propTypes["default"].string,
  size: _propTypes["default"].string,
  testId: _propTypes["default"].string,
  theme: _propTypes["default"].object.isRequired,
  titleFormatPattern: _propTypes["default"].string,
  titleFormatter: _propTypes["default"].func,
  value: _propTypes["default"].object
};
DateTimeSelector.defaultProps = {
  closeOnDateChange: true,
  hasError: false,
  placeholder: 'Select Date',
  finishButtonLabel: 'Finish',
  inputIcon: undefined,
  iconLeft: null,
  isClearable: false,
  isDisabled: false,
  onBlur: _lodash["default"],
  onDateChange: _lodash["default"],
  onFocus: _lodash["default"],
  otherCalendarProps: {},
  id: undefined,
  size: 'large',
  testId: 'DATE_TIME_SELECTOR',
  titleFormatPattern: 'MM/dd/yyyy',
  titleFormatter: undefined,
  value: undefined
};
var _default = (0, _oxygenConfig.withTheme)(DateTimeSelector, 'dateTimeSelector');
exports["default"] = _default;